/**
 * @generated SignedSource<<f6b1bd4fc8a5eb40b77f32da68e58668>>
 * @relayHash 9f86b75b59fa89c77d298a5a5722f7b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 586d4c9bcd99e5c399b99885d2409ba2320725000f21d7c91a23478fe71ceb2d

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PlansListRefactoredQuery$variables = {
  cloudId: string;
  currentURLPath?: AGG$URL | null | undefined;
  entityAriPlans?: string | null | undefined;
  ownerAri?: string | null | undefined;
};
export type PlansListRefactoredQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PlansListRefactored">;
};
export type PlansListRefactoredQuery = {
  response: PlansListRefactoredQuery$data;
  variables: PlansListRefactoredQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currentURLPath"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityAriPlans"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ownerAri"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v5 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "planId"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          },
          {
            "kind": "ScalarField",
            "name": "isReadOnly"
          },
          {
            "kind": "ScalarField",
            "name": "planStatus"
          },
          {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isFavourite"
              },
              (v3/*: any*/)
            ]
          },
          {
            "concreteType": "JiraScenario",
            "kind": "LinkedField",
            "name": "scenario",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "scenarioId"
              },
              (v3/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "url"
                  }
                ],
                "type": "JiraSoftwareBuiltInNavigationItem"
              },
              (v4/*: any*/)
            ]
          }
        ],
        "type": "JiraPlan"
      },
      (v4/*: any*/)
    ]
  }
],
v6 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PlansListRefactoredQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "currentURLPath",
            "variableName": "currentURLPath"
          }
        ],
        "kind": "FragmentSpread",
        "name": "PlansListRefactored"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PlansListRefactoredQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "favouritePlans",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "sort": {
                    "order": "DESC"
                  },
                  "type": "PLAN"
                }
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 15
              }
            ],
            "concreteType": "JiraFavouriteConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              {
                "concreteType": "JiraFavouriteEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v5/*: any*/)
              },
              (v6/*: any*/)
            ]
          },
          {
            "alias": "recentPlans",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Variable",
                "name": "currentURL",
                "variableName": "currentURLPath"
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 20
              },
              {
                "kind": "Literal",
                "name": "types",
                "value": [
                  "PLAN"
                ]
              }
            ],
            "concreteType": "JiraSearchableEntityConnection",
            "kind": "LinkedField",
            "name": "recentItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSearchableEntityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v5/*: any*/)
              },
              (v6/*: any*/)
            ]
          }
        ]
      },
      {
        "alias": "plansOrder",
        "args": [
          {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "entityAriPlans"
          },
          {
            "kind": "Variable",
            "name": "ownerAri",
            "variableName": "ownerAri"
          }
        ],
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": [
          {
            "concreteType": "SettingsMenuItemConnection",
            "kind": "LinkedField",
            "name": "sidebar",
            "plural": false,
            "selections": [
              {
                "concreteType": "SettingsMenuItem",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "menuId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "visible"
                  }
                ]
              }
            ]
          },
          (v3/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "586d4c9bcd99e5c399b99885d2409ba2320725000f21d7c91a23478fe71ceb2d",
    "metadata": {},
    "name": "PlansListRefactoredQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2ddac3dbb3259d27dc6f11175b355784";

export default node;
